import "../components/fancy-slider.js";
import "../components/custom-asside-menu.js";
import "../components/custom-search-api";
import "../components/pdf-to-canvas.js";
import "../components/more-content";
import '../components/custom-more-elements.js';
